import { changePasswordContract } from './auth/definitions/change-password.contract.js';
import { getMeContract } from './auth/definitions/get-me.contract.js';
import { loginUserContract } from './auth/definitions/login-user.contract.js';
import { refreshTokenContract } from './auth/definitions/refresh-token.contract.js';
import { createContactContract } from './contacts/definitions/create-contact.contract.js';
import { findContactByPhoneContract } from './contacts/definitions/find-contact-by-phone.contract.js';
import { searchContactsContract } from './contacts/definitions/search-contacts.contract.js';
import { updateContactContract } from './contacts/definitions/update-contact.contract.js';
import { getDashboardQueuesContract } from './dashboard/definitions/get-dashboard-queues.contract.js';
import { getDashboardStatsContract } from './dashboard/definitions/get-dashboard-stats.contract.js';
import { listRecentEstimatesContract } from './dashboard/definitions/list-recent-estimates.contract.js';
import { applyEstimateTemplateContract } from './estimates/definitions/apply-estimate-template.contract.js';
import { checkEstimateVinContract } from './estimates/definitions/check-estimate-vin.contract.js';
import { createEstimateContract } from './estimates/definitions/create-estimate.contract.js';
import { getEstimateContract } from './estimates/definitions/get-estimate.contract.js';
import { getEstimateQuickRangeContract } from './estimates/definitions/get-estimate-quick-range.contract.js';
import { listEstimateActivityContract } from './estimates/definitions/list-estimate-activity.contract.js';
import { listEstimatesContract } from './estimates/definitions/list-estimates.contract.js';
import { previewEstimateTemplateContract } from './estimates/definitions/preview-estimate-template.contract.js';
import { selectEstimateQuickCategoryContract } from './estimates/definitions/select-estimate-quick-category.contract.js';
import { updateEstimateContract } from './estimates/definitions/update-estimate.contract.js';
import { getHealthContract } from './health/definitions/get-health.contract.js';
import { listSimulatorEstimatesContract, removeSimulatorEstimateContract, saveSimulatorEstimateContract } from './simulator/definitions/index.js';
import { getInspectionContract } from './inspections/definitions/get-inspection.contract.js';
import { updateInspectionContract } from './inspections/definitions/update-inspection.contract.js';
import { createPolicyDraftContract } from './policies/definitions/create-policy-draft.contract.js';
import { getPolicyInputCatalogContract } from './policies/definitions/get-policy-input-catalog.contract.js';
import { getPolicyVersionContract } from './policies/definitions/get-policy-version.contract.js';
import { getPublishedPolicyContract } from './policies/definitions/get-published-policy.contract.js';
import { listPolicyVersionsContract } from './policies/definitions/list-policy-versions.contract.js';
import { publishPolicyContract } from './policies/definitions/publish-policy.contract.js';
import { updatePolicyDraftContract } from './policies/definitions/update-policy-draft.contract.js';
import { validatePolicyDraftContract } from './policies/definitions/validate-policy-draft.contract.js';
import { archiveTemplateContract } from './templates/definitions/archive-template.contract.js';
import { cloneTemplateVersionContract } from './templates/definitions/clone-template-version.contract.js';
import { createTemplateContract } from './templates/definitions/create-template.contract.js';
import { createTemplateDraftVersionContract } from './templates/definitions/create-template-draft-version.contract.js';
import { getTemplateContract } from './templates/definitions/get-template.contract.js';
import { getTemplateParamCatalogContract } from './templates/definitions/get-template-param-catalog.contract.js';
import { getTemplateVersionContract } from './templates/definitions/get-template-version.contract.js';
import { applyDepreciationPresetContract } from './templates/definitions/apply-depreciation-preset.contract.js';
import { listDepreciationPresetsContract } from './templates/definitions/list-depreciation-presets.contract.js';
import { listTemplatesContract } from './templates/definitions/list-templates.contract.js';
import { previewPolicyImpactContract } from './policies/definitions/preview-policy-impact.contract.js';
import { previewTemplateVersionContract } from './templates/definitions/preview-template-version.contract.js';
import { publishTemplateVersionContract } from './templates/definitions/publish-template-version.contract.js';
import { setTemplateReferencePriceContract } from './templates/definitions/set-template-reference-price.contract.js';
import { updateDepreciationPresetContract } from './templates/definitions/update-depreciation-preset.contract.js';
import { updateTemplateContract } from './templates/definitions/update-template.contract.js';
import { updateTemplateDraftVersionContract } from './templates/definitions/update-template-draft-version.contract.js';
import { getCurrentTenantContract } from './tenant/definitions/get-current-tenant.contract.js';
import { createUserContract } from './users/definitions/create-user.contract.js';
import { disableUserContract } from './users/definitions/disable-user.contract.js';
import { listUsersContract } from './users/definitions/list-users.contract.js';
import { resetUserPasswordContract } from './users/definitions/reset-user-password.contract.js';
import { updateUserRoleContract } from './users/definitions/update-user-role.contract.js';
import { computeValuationContract } from './valuations/definitions/compute-valuation.contract.js';
import { getValuationContract } from './valuations/definitions/get-valuation.contract.js';
import { listValuationsContract } from './valuations/definitions/list-valuations.contract.js';
import { saveValuationContract } from './valuations/definitions/save-valuation.contract.js';
import { closeEstimateNoDealContract } from './estimates/definitions/close-estimate-no-deal.contract.js';
import { purchaseEstimateContract } from './estimates/definitions/purchase-estimate.contract.js';
import { reopenEstimateContract } from './estimates/definitions/reopen-estimate.contract.js';
import { shareEstimateOfferContract } from './estimates/definitions/share-estimate-offer.contract.js';
import { changeVehicleStatusContract } from './vehicles/definitions/change-vehicle-status.contract.js';
import { correctVehicleContract } from './vehicles/definitions/correct-vehicle.contract.js';
import { getVehicleContract } from './vehicles/definitions/get-vehicle.contract.js';
import { getVehicleAttributeOptionsContract } from './vehicles/definitions/get-vehicle-attribute-options.contract.js';
import { listVehicleActivityContract } from './vehicles/definitions/list-vehicle-activity.contract.js';
import { listVehiclesContract } from './vehicles/definitions/list-vehicles.contract.js';
import { previewVehicleSaleContract } from './vehicles/definitions/preview-vehicle-sale.contract.js';
import { updateVehicleContract } from './vehicles/definitions/update-vehicle.contract.js';
import { addCostWorkOptionContract } from './costs/definitions/add-cost-work-option.contract.js';
import { addManualCostContract } from './costs/definitions/add-manual-cost.contract.js';
import { listCostItemsContract } from './costs/definitions/list-cost-items.contract.js';
import { removeCostItemContract } from './costs/definitions/remove-cost-item.contract.js';
import { updateCostItemContract } from './costs/definitions/update-cost-item.contract.js';
import { waiveCostItemContract } from './costs/definitions/waive-cost-item.contract.js';
import { decideApprovalContract } from './approvals/definitions/decide-approval.contract.js';
import { listApprovalsByOwnerContract } from './approvals/definitions/list-approvals-by-owner.contract.js';
import { listPendingApprovalsContract } from './approvals/definitions/list-pending-approvals.contract.js';
import { requestApprovalContract } from './approvals/definitions/request-approval.contract.js';
import { getDocumentPhotoSetContract } from './documents/definitions/get-document-photo-set.contract.js';
import { listDocumentsContract } from './documents/definitions/list-documents.contract.js';
import { updateDocumentMetaContract } from './documents/definitions/update-document-meta.contract.js';
import { addServiceEventContract } from './history/definitions/add-service-event.contract.js';
import { listServiceEventsContract } from './history/definitions/list-service-events.contract.js';
import { removeServiceEventContract } from './history/definitions/remove-service-event.contract.js';
import { updateServiceEventContract } from './history/definitions/update-service-event.contract.js';
import { getTradeInContract } from './trade-in/definitions/get-trade-in.contract.js';
import { upsertTradeInContract } from './trade-in/definitions/upsert-trade-in.contract.js';
// Every zod schema, in one place, so `used-vehicle-contracts/schemas` and this entry point can never drift.
export * from './schemas.js';
export * from './auth/definitions/index.js';
export * from './users/definitions/index.js';
export * from './policies/definitions/index.js';
export * from './templates/definitions/index.js';
export * from './estimates/definitions/index.js';
export * from './vehicles/definitions/index.js';
export * from './costs/definitions/index.js';
export * from './approvals/definitions/index.js';
export * from './trade-in/definitions/index.js';
export * from './documents/definitions/index.js';
export * from './history/definitions/index.js';
export * from './inspections/definitions/index.js';
export * from './valuations/definitions/index.js';
export * from './dashboard/definitions/index.js';
export * from './contacts/definitions/index.js';
export * from './tenant/definitions/index.js';
export * from './health/definitions/index.js';
export * from './simulator/definitions/index.js';
/**
 * The single aggregate contract. The service implements it with `@Implement(usedVehicleContract.<area>.<op>)`
 * and the web app consumes it through `OpenAPILink(usedVehicleContract, …)`.
 *
 * Areas arrive phase by phase (plan §10). Phase 3 adds `estimates`, `inspections`, `valuations.compute`
 * and `dashboard`; `vehicles`, `costs`, `history`, `documents`, `tradeIn` and `approvals` join the
 * object below without changing anything that is already here.
 */
export const usedVehicleContract = {
    auth: {
        login: loginUserContract,
        refresh: refreshTokenContract,
        me: getMeContract,
        changePassword: changePasswordContract,
    },
    users: {
        list: listUsersContract,
        create: createUserContract,
        updateRole: updateUserRoleContract,
        disable: disableUserContract,
        resetPassword: resetUserPasswordContract,
    },
    policies: {
        getPublished: getPublishedPolicyContract,
        inputCatalog: getPolicyInputCatalogContract,
        // The static `/policies/versions` list is declared before the `{versionId}` sibling (plan §2.4).
        listVersions: listPolicyVersionsContract,
        getVersion: getPolicyVersionContract,
        createDraft: createPolicyDraftContract,
        updateDraft: updatePolicyDraftContract,
        validateDraft: validatePolicyDraftContract,
        impactPreview: previewPolicyImpactContract,
        publish: publishPolicyContract,
    },
    templates: {
        // Static paths are declared before their `{templateId}` / `{versionId}` siblings (plan §2.4).
        list: listTemplatesContract,
        paramCatalog: getTemplateParamCatalogContract,
        depreciationPresets: listDepreciationPresetsContract,
        updateDepreciationPreset: updateDepreciationPresetContract,
        applyDepreciationPreset: applyDepreciationPresetContract,
        getVersion: getTemplateVersionContract,
        previewVersion: previewTemplateVersionContract,
        updateDraftVersion: updateTemplateDraftVersionContract,
        publishVersion: publishTemplateVersionContract,
        cloneVersion: cloneTemplateVersionContract,
        get: getTemplateContract,
        create: createTemplateContract,
        update: updateTemplateContract,
        createDraftVersion: createTemplateDraftVersionContract,
        archive: archiveTemplateContract,
        setReferencePrice: setTemplateReferencePriceContract,
    },
    estimates: {
        // Static paths are declared before their `{estimateId}` siblings (plan §2.4).
        list: listEstimatesContract,
        checkVin: checkEstimateVinContract,
        create: createEstimateContract,
        get: getEstimateContract,
        update: updateEstimateContract,
        applyTemplatePreview: previewEstimateTemplateContract,
        applyTemplate: applyEstimateTemplateContract,
        quickRange: getEstimateQuickRangeContract,
        selectQuickCategory: selectEstimateQuickCategoryContract,
        shareOffer: shareEstimateOfferContract,
        closeNoDeal: closeEstimateNoDealContract,
        reopen: reopenEstimateContract,
        purchase: purchaseEstimateContract,
        listActivity: listEstimateActivityContract,
    },
    vehicles: {
        // The static `/vehicles/attribute-options` path is declared before its `{vehicleId}` sibling (plan §2.4).
        list: listVehiclesContract,
        attributeOptions: getVehicleAttributeOptionsContract,
        get: getVehicleContract,
        update: updateVehicleContract,
        // Read-only, and declared before `changeStatus` because it is what the sale dialog asks first.
        salePreview: previewVehicleSaleContract,
        changeStatus: changeVehicleStatusContract,
        correct: correctVehicleContract,
        listActivity: listVehicleActivityContract,
    },
    costs: {
        list: listCostItemsContract,
        addWorkOption: addCostWorkOptionContract,
        addManual: addManualCostContract,
        update: updateCostItemContract,
        remove: removeCostItemContract,
        waive: waiveCostItemContract,
    },
    approvals: {
        // `/approvals/pending` is declared before the `{approvalId}` sibling (plan §2.4).
        listPending: listPendingApprovalsContract,
        listByOwner: listApprovalsByOwnerContract,
        request: requestApprovalContract,
        decide: decideApprovalContract,
    },
    tradeIn: {
        get: getTradeInContract,
        upsert: upsertTradeInContract,
    },
    documents: {
        // The static `photo-set` path is declared before its `{id}` sibling (plan §2.4). Upload, download
        // and replace are **not** here: multipart and streams belong to
        // `presenters/http/documents.controller.ts` (plan §6).
        list: listDocumentsContract,
        photoSet: getDocumentPhotoSetContract,
        updateMeta: updateDocumentMetaContract,
    },
    history: {
        list: listServiceEventsContract,
        add: addServiceEventContract,
        update: updateServiceEventContract,
        remove: removeServiceEventContract,
    },
    inspections: {
        get: getInspectionContract,
        update: updateInspectionContract,
    },
    valuations: {
        compute: computeValuationContract,
        save: saveValuationContract,
        list: listValuationsContract,
        get: getValuationContract,
    },
    dashboard: {
        stats: getDashboardStatsContract,
        queues: getDashboardQueuesContract,
        recentEstimates: listRecentEstimatesContract,
    },
    contacts: {
        search: searchContactsContract,
        findByPhone: findContactByPhoneContract,
        create: createContactContract,
        update: updateContactContract,
    },
    tenant: {
        current: getCurrentTenantContract,
    },
    health: {
        get: getHealthContract,
    },
    simulator: {
        // Public, like `health.get`: the depreciation simulator is a testing tool with no sign-in. The
        // static `/simulator/estimates` list is declared before the `{id}` sibling (plan §2.4).
        list: listSimulatorEstimatesContract,
        save: saveSimulatorEstimateContract,
        remove: removeSimulatorEstimateContract,
    },
};
//# sourceMappingURL=index.js.map